import { Seq } from 'immutable'
export default function stubImmutableIndexedSeq() {
  return Seq.Indexed([])
}
